import { ICidEventModel } from '@apps-common/types/cid-event-code'
import { ISelectOption } from '@apps-common/types/form'

export const CID_EVENT_TYPE_EVENT: ISelectOption = { label: 'Event', value: 'E' }
export const CID_EVENT_TYPE_RESTORE: ISelectOption = { label: 'Restore', value: 'R' }

export const ALARM_EVENT_TYPE_DISARM: ISelectOption = { label: 'Disarm', value: 'E' }
export const ALARM_EVENT_TYPE_ARM: ISelectOption = { label: 'Arm', value: 'R' }

export const TRIGGER_CID_EVENT_TYPES: ISelectOption[] = [CID_EVENT_TYPE_EVENT, CID_EVENT_TYPE_RESTORE]

export const TRIGGER_ALARM_EVENT_TYPES: ISelectOption[] = [ALARM_EVENT_TYPE_ARM, ALARM_EVENT_TYPE_DISARM]

// all cid event codes
export const CID_EVENT_CODES: ICidEventModel[] = [
  { description: 'Medical', code: '100' },
  { description: 'Personal Emergency', code: '101' },
  { description: 'Fail to report in', code: '102' },
  { description: 'Fire', code: '110' },
  { description: 'Smoke', code: '111' },
  { description: 'Combustion', code: '112' },
  { description: 'Water Flow', code: '113' },
  { description: 'Heat', code: '114' },
  { description: 'Pull Station', code: '115' },
  { description: 'Duct', code: '116' },
  { description: 'Flame', code: '117' },
  { description: 'Near Alarm', code: '118' },
  { description: 'Panic', code: '120' },
  { description: 'Duress', code: '121' },
  { description: 'Silent', code: '122' },
  { description: 'Audible', code: '123' },
  { description: 'Duress – Access granted', code: '124' },
  { description: 'Duress – Egress granted', code: '125' },
  { description: 'Hold-up suspicion print', code: '126' },
  { description: 'Panic Verifier', code: '129' },
  { description: 'Burglary', code: '130' },
  { description: 'Perimeter', code: '131' },
  { description: 'Interior', code: '132' },
  { description: '24 Hour (Safe)', code: '133' },
  { description: 'Entry/Exit', code: '134' },
  { description: 'Day/Night', code: '135' },
  { description: 'Outdoor', code: '136' },
  { description: 'Tamper', code: '137' },
  { description: 'Near alarm', code: '138' },
  { description: 'Intrusion Verifier', code: '139' },
  { description: 'General Alarm', code: '140' },
  { description: 'Polling loop open', code: '141' },
  { description: 'Polling loop short', code: '142' },
  { description: 'Expansion module failure', code: '143' },
  { description: 'Sensor tamper', code: '144' },
  { description: 'Expansion module tamper', code: '145' },
  { description: 'Silent Burglary', code: '146' },
  { description: 'Sensor Supervision Failure', code: '147' },
  { description: '24 Hour Non-Burglary', code: '150' },
  { description: 'Gas detected', code: '151' },
  { description: 'Refrigeration', code: '152' },
  { description: 'Loss of heat', code: '153' },
  { description: 'Water Leakage', code: '154' },
  { description: 'Foil Break', code: '155' },
  { description: 'Day Trouble', code: '156' },
  { description: 'Low bottled gas level', code: '157' },
  { description: 'High temp', code: '158' },
  { description: 'Low temp', code: '159' },
  { description: 'Loss of air flow', code: '161' },
  { description: 'Carbon Monoxide detected', code: '162' },
  { description: 'Tank level', code: '163' },
  { description: 'High Humidity', code: '168' },
  { description: 'Low Humidity', code: '169' },
  { description: 'Fire Supervisory', code: '200' },
  { description: 'Low water pressure', code: '201' },
  { description: 'Low CO2', code: '202' },
  { description: 'Gate valve sensor', code: '203' },
  { description: 'Low water level', code: '204' },
  { description: 'Pump activated', code: '205' },
  { description: 'Pump failure', code: '206' },
  { description: 'System Trouble', code: '300' },
  { description: 'AC Loss', code: '301' },
  { description: 'Low system battery', code: '302' },
  { description: 'RAM Checksum bad', code: '303' },
  { description: 'ROM checksum bad', code: '304' },
  { description: 'System reset', code: '305' },
  { description: 'Panel programming changed', code: '306' },
  { description: 'Self-test failure', code: '307' },
  { description: 'System shutdown', code: '308' },
  { description: 'Battery test failure', code: '309' },
  { description: 'Ground fault', code: '310' },
  { description: 'Battery Missing/Dead', code: '311' },
  { description: 'Power Supply Overcurrent', code: '312' },
  { description: 'Engineer Reset', code: '313' },
  { description: 'Primary Power Supply Failure', code: '314' },
  { description: 'System Tamper', code: '316' },
  { description: 'Sounder/Relay', code: '320' },
  { description: 'Bell 1', code: '321' },
  { description: 'Bell 2', code: '322' },
  { description: 'Alarm relay', code: '323' },
  { description: 'Trouble relay', code: '324' },
  { description: 'Reversing relay', code: '325' },
  { description: 'Notification Appliance Ckt. # 3', code: '326' },
  { description: 'Notification Appliance Ckt. #4', code: '327' },
  { description: 'System Peripheral trouble', code: '330' },
  { description: 'Polling loop open', code: '331' },
  { description: 'Polling loop short', code: '332' },
  { description: 'Expansion module failure', code: '333' },
  { description: 'Repeater failure', code: '334' },
  { description: 'Local printer out of paper', code: '335' },
  { description: 'Local printer failure', code: '336' },
  { description: 'Exp. Module DC Loss', code: '337' },
  { description: 'Exp. Module Low Batt.', code: '338' },
  { description: 'Exp. Module Reset', code: '339' },
  { description: 'Exp. Module Tamper', code: '341' },
  { description: 'Exp. Module AC Loss', code: '342' },
  { description: 'Exp. Module self-test fail', code: '343' },
  { description: 'RF Receiver Jam Detect', code: '344' },
  { description: 'AES Encryption disabled/ enabled', code: '345' },
  { description: 'Communication trouble', code: '350' },
  { description: 'Telco 1 fault', code: '351' },
  { description: 'Telco 2 fault', code: '352' },
  { description: 'Long Range Radio xmitter fault', code: '353' },
  { description: 'Failure to communicate event', code: '354' },
  { description: 'Loss of Radio supervision', code: '355' },
  { description: 'Loss of central polling', code: '356' },
  { description: 'Long Range Radio VSWR problem', code: '357' },
  { description: 'Periodic Comm Test Fail /Restore', code: '358' },
  { description: 'AlarmNet Communications Failure', code: '359' },
  { description: 'New Registration', code: '360' },
  { description: 'Authorized Substitution Registration', code: '361' },
  { description: 'Unauthorized Substitution Registration', code: '362' },
  { description: 'Module Firmware Update', code: '365' },
  { description: 'Module Firmware Update Failed', code: '366' },
  { description: 'Protection loop', code: '370' },
  { description: 'Protection loop open', code: '371' },
  { description: 'Protection loop short', code: '372' },
  { description: 'Fire trouble', code: '373' },
  { description: 'Exit error alarm (zone)', code: '374' },
  { description: 'Panic zone trouble', code: '375' },
  { description: 'Hold-up zone trouble', code: '376' },
  { description: 'Swinger Trouble', code: '377' },
  { description: 'Cross-zone Trouble', code: '378' },
  { description: 'Sensor trouble', code: '380' },
  { description: 'Loss of supervision - RF', code: '381' },
  { description: 'Loss of supervision - RPM', code: '382' },
  { description: 'Sensor tamper', code: '383' },
  { description: 'RF low battery', code: '384' },
  { description: 'Smoke detector Hi sensitivity', code: '385' },
  { description: 'Smoke detector Low sensitivity', code: '386' },
  { description: 'Intrusion detector Hi sensitivity', code: '387' },
  { description: 'Intrusion detector Low sensitivity', code: '388' },
  { description: 'Sensor self-test failure', code: '389' },
  { description: 'Sensor Watch trouble', code: '391' },
  { description: 'Drift Compensation Error', code: '392' },
  { description: 'Maintenance Alert', code: '393' },
  { description: 'CO Detector needs replacement', code: '394' },
  { description: 'Open/Close', code: '400' },
  { description: 'O/C by user', code: '401' },
  { description: 'Group O/C', code: '402' },
  { description: 'Automatic O/C', code: '403' },
  { description: 'Cancel', code: '406' },
  { description: 'Remote arm/disarm', code: '407' },
  { description: 'Quick arm', code: '408' },
  { description: 'Keyswitch O/C', code: '409' },
  { description: 'Armed STAY', code: '441' },
  { description: 'Keyswitch Armed STAY', code: '442' },
  { description: 'Armed with System Trouble Override', code: '443' },
  { description: 'Exception O/C', code: '450' },
  { description: 'Early O/C', code: '451' },
  { description: 'Late O/C', code: '452' },
  { description: 'Failed to Open', code: '453' },
  { description: 'Failed to Close', code: '454' },
  { description: 'Auto-arm Failed', code: '455' },
  { description: 'Partial Arm', code: '456' },
  { description: 'Exit Error (user)', code: '457' },
  { description: 'User on Premises', code: '458' },
  { description: 'Recent Close', code: '459' },
  { description: 'Wrong Code Entry', code: '461' },
  { description: 'Legal Code Entry', code: '462' },
  { description: 'Re-arm after Alarm', code: '463' },
  { description: 'Auto-arm Time Extended', code: '464' },
  { description: 'Panic Alarm Reset', code: '465' },
  { description: 'Service On/Off Premises', code: '466' },
  { description: 'Callback request made', code: '411' },
  { description: 'Successful download/access', code: '412' },
  { description: 'Unsuccessful access', code: '413' },
  { description: 'System shutdown command received', code: '414' },
  { description: 'Dialer shutdown command received', code: '415' },
  { description: 'Successful Upload', code: '416' },
  { description: 'Access denied', code: '421' },
  { description: 'Access report by user', code: '422' },
  { description: 'Forced Access', code: '423' },
  { description: 'Egress Denied', code: '424' },
  { description: 'Egress Granted', code: '425' },
  { description: 'Access Door propped open', code: '426' },
  { description: 'Access point Door Status Monitor trouble', code: '427' },
  { description: 'Access point Request To Exit trouble', code: '428' },
  { description: 'Access program mode entry', code: '429' },
  { description: 'Access program mode exit', code: '430' },
  { description: 'Access threat level change', code: '431' },
  { description: 'Access relay/trigger fail', code: '432' },
  { description: 'Access RTE shunt', code: '433' },
  { description: 'Access DSM shunt', code: '434' },
  { description: 'Second Person Access', code: '435' },
  { description: 'Irregular Access', code: '436' },
  { description: 'Access reader disable', code: '501' },
  { description: 'Sounder/Relay Disable', code: '520' },
  { description: 'Bell 1 disable', code: '521' },
  { description: 'Bell 2 disable', code: '522' },
  { description: 'Alarm relay disable', code: '523' },
  { description: 'Trouble relay disable', code: '524' },
  { description: 'Reversing relay disable', code: '525' },
  { description: 'Notification Appliance Ckt. # 3 disable', code: '526' },
  { description: 'Notification Appliance Ckt. # 4 disable', code: '527' },
  { description: 'Module Added', code: '531' },
  { description: 'Module Removed', code: '532' },
  { description: 'Dialer disabled', code: '551' },
  { description: 'Radio transmitter disabled', code: '552' },
  { description: 'Remote Upload/Download disabled', code: '553' },
  { description: 'Zone/Sensor bypass', code: '570' },
  { description: 'Fire bypass', code: '571' },
  { description: '24 Hour zone bypass', code: '572' },
  { description: 'Burg. Bypass', code: '573' },
  { description: 'Group bypass', code: '574' },
  { description: 'Swinger bypass', code: '575' },
  { description: 'Access zone shunt', code: '576' },
  { description: 'Access point bypass', code: '577' },
  { description: 'Vault Bypass', code: '578' },
  { description: 'Vent Zone Bypass', code: '579' },
  { description: 'Manual trigger test report', code: '601' },
  { description: 'Periodic test report', code: '602' },
  { description: 'Periodic RF transmission', code: '603' },
  { description: 'Fire test', code: '604' },
  { description: 'Status report to follow', code: '605' },
  { description: 'Listen-in to follow', code: '606' },
  { description: 'Walk test mode', code: '607' },
  { description: 'Periodic test - System Trouble Present', code: '608' },
  { description: 'Video Xmitter active', code: '609' },
  { description: 'Point tested OK', code: '611' },
  { description: 'Point not tested', code: '612' },
  { description: 'Intrusion Zone Walk Tested', code: '613' },
  { description: 'Fire Zone Walk Tested', code: '614' },
  { description: 'Panic Zone Walk Tested', code: '615' },
  { description: 'Service Request', code: '616' },
  { description: 'Event Log reset', code: '621' },
  { description: 'Event Log 50% full', code: '622' },
  { description: 'Event Log 90% full', code: '623' },
  { description: 'Event Log overflow', code: '624' },
  { description: 'Time/Date reset', code: '625' },
  { description: 'Time/Date inaccurate', code: '626' },
  { description: 'Program mode entry', code: '627' },
  { description: 'Program mode exit', code: '628' },
  { description: '32 Hour Event log marker', code: '629' },
  { description: 'Schedule change', code: '630' },
  { description: 'Exception schedule change', code: '631' },
  { description: 'Access schedule change', code: '632' },
  { description: 'Senior Watch Trouble', code: '641' },
  { description: 'Latch-key Supervision', code: '642' },
  { description: 'System Inactivity', code: '654' },
  { description: 'User Code X modified by Installer', code: '655' },
  { description: 'Installer Test', code: '704' },
  { description: 'Download Abort', code: '900' },
  { description: 'Download Start/End', code: '901' },
  { description: 'Download Interrupted', code: '902' },
  { description: 'Device Flash Update Started/Completed', code: '903' },
  { description: 'Device Flash Update Failed', code: '904' },
  { description: 'Auto-close with Bypass', code: '910' },
  { description: 'Bypass Closing', code: '911' },
  { description: 'Fire Alarm Silence', code: '912' },
  { description: 'Supervisory Point test Start/End', code: '913' },
  { description: 'Hold-up test Start/End', code: '914' },
  { description: 'Burg. Test Print Start/End', code: '915' },
  { description: 'Supervisory Test Print Start/End', code: '916' },
  { description: 'Burg. Diagnostics Start/End', code: '917' },
  { description: 'Fire Diagnostics Start/End', code: '918' },
  { description: 'Untyped diagnostics', code: '919' },
  { description: 'Trouble Closing (closed with burg. during exit)', code: '920' },
  { description: 'Access Denied Code Unknown', code: '921' },
  { description: 'Supervisory Point Alarm', code: '922' },
  { description: 'Supervisory Point Bypass', code: '923' },
  { description: 'Supervisory Point Trouble', code: '924' },
  { description: 'Hold-up Point Bypass', code: '925' },
  { description: 'AC Failure for 4 hours', code: '926' },
  { description: 'Output Trouble', code: '927' },
  { description: 'User code for event', code: '928' },
  { description: 'Log-off', code: '929' },
  { description: 'CS Connection Failure', code: '954' },
  { description: 'Rcvr Database Connection Fail/Restore', code: '961' },
  { description: 'License Expiration Notify', code: '962' },
  { description: 'Custom Event', code: 'custom' }
]
